<template>
  <fts-design-modal
    width="1200px"
    class="fts-logic-service-design-modal"
    ref="ftsDesignModal">
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <font-awesome-icon class="design-modal-header-icon default" :icon="['fas', 'scroll']" />
        <input 
          type="text" 
          placeholder="Please enter a name"
          class="fts-form-control design-modal-header-input"
          :class="{error: $v.formData.name && $v.formData.name.$error}" 
          v-model="formData.name"
          spellcheck="false"
          ref="designerName">
      </div>
      <!-- error message -->
      <div class="design-modal-form-error" v-if="error('name')">
        {{error('name')}}
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">Logic</span>
      <span class="design-modal-header-description">
        extra boost of logics
      </span>
    </template>
    <!-- body -->
    <template #body>
      <!-- description -->
      <div class="fts-form-group">
        <fts-contenteditable
          v-model="formData.description"
          text-wrap
          placeholder="enter description (optional)"
        />
      </div>
      <!-- script -->
      <fts-form-element
        :form-data="formData"
        :item="{
          fieldName: 'script',
          icon: 'fts-icon-text',
        }"
        comfort-design>
        <fts-script-editor
          slot="formElement"
          slot-scope="{formData, item}"
          editor-id="logicServiceScript"
          v-model="formData[item.fieldName]"
          lang="python" />
      </fts-form-element>
      <!-- payload -->
      <fts-form-element
        :form-data="formData"
        :item="{
          fieldName: 'payload',
          icon: 'fts-icon-text',
        }"
        comfort-design>
        <fts-script-editor
          slot="formElement"
          slot-scope="{formData, item}"
          editor-id="logicServicePayload"
          v-model="formData[item.fieldName]"
          lang="python" />
      </fts-form-element>
      <!-- test -->
      <fts-btn outline color="primary" text-transform-init @click="testLogic">
       Test run
      </fts-btn>
    </template>
    <!-- footer -->
    <template #footerLeft>
      <fts-btn text icon @click="remove" v-if="isExist">
        <font-awesome-icon :icon="['far', 'trash-alt']" />
      </fts-btn>
    </template>
    <template #footerRight>
      <fts-btn text @click="beforeClose">Cancel</fts-btn>

      <fts-btn color="primary" text @click="done(true)">
        <font-awesome-icon :icon="['fas', 'check']" /> Save
      </fts-btn>

      <fts-btn outline color="primary" @click="done">
        <font-awesome-icon :icon="['fas', 'check']" /> Ok
      </fts-btn>
    </template>
  </fts-design-modal>
</template>

<script>
import Vue from "vue";
import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import changesets from "diff-json";

import validator from "../commons/designValidator";

import FTSDesignModal from "./FTSDesignModal";
import FTSBtn from "../elements/FTSBtn";
import FTSFormElement from "../elements/FTSFormElement";
import FTSScriptEditor from "./FTSScriptEditor";
import FTSContenteditable from "../elements/FTSContenteditable";

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
    "fts-form-element": FTSFormElement,
    "fts-script-editor": FTSScriptEditor,
    "fts-contenteditable": FTSContenteditable,
  },
  data: () => ({
    formData: null,
    originalData: null,
    resolve: null,
    saveCallBack: null,
  }),
  validations() {
    let formData = {};
    formData = validator.activityDesign(this.logicServices);
    return { formData };
  },
  methods: {
    async show(item, saveCallBack) {
      this.saveCallBack = saveCallBack;
      this.formData = _.cloneDeep(item);

      if (!this.formData.script)
        this.$set(this.formData, "script", "");
      if (!this.formData.payload)
        this.$set(this.formData, "payload", "");
  
      return new Promise(resolve => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show({
          beforeCloseHandler: () => {
            const diff = changesets.diff(this.formData, this.originalData)
            if (diff && diff.length) {
              this.$modal.show("dialog", {
                title: "Confirm discard changes",
                text: "Discard all changes?",
                buttons: [
                  { title: "Cancel" },
                  {
                    title: "Discard",
                    default: true,
                    handler: () => {
                      this.$modal.hide("dialog");
                      this.reset();
                    },
                  },
                ],
              });             
            } else {
              this.reset();
            }
          },
        });

        this.$nextTick(() => {
          this.originalData = _.cloneDeep(this.formData);
          this.$refs.designerName.focus();
        });
      })
    },
    done(save) {
      this.$v.formData.$touch();
      if (!this.$v.formData.$invalid) {
        if (save) {
          this.saveCallBack && this.saveCallBack(this.formData);
          this.originalData = _.cloneDeep(this.formData);
        } else {
          this.resolve && this.resolve(this.formData);
          this.reset();
        }
      }
    },
    beforeClose() {
      this.$refs.ftsDesignModal.beforeClose();
    },
    remove() {
      this.$modal.show("dialog", {
        title: "Confirmation",
        text: `Delete ${this.formData.name}?`,
        buttons: [
          { title: "Cancel" },
          {
            title: "Delete",
            default: true,
            handler: () => {
              this.$modal.hide("dialog");
              this.resolve && this.resolve(true);
              this.reset();
            },
          },
        ],
      });  
    },
    reset() {
      this.$v.$reset();
      this.$refs.ftsDesignModal.close();
    },
    error(key) {
      return validator.logicServiceDesignError(this.$v.formData, key);
    },
    async testLogic() {
      await this.$store.dispatch("testConfiguration", {
        item: this.formData,
        type: "logicService",
      });
    },
  }, 
  computed: {
    logicServices() {
      return this.$store.getters.canvasLogicServices;
    },
    isExist() {
      return Boolean(this.logicServices.find(x => x.id === this.formData.id));
    },
  }
}
</script>